import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

interface EditLog {
    id: number;
    date: string;
    user: string;
    changes: string;
}

const rows: EditLog[] = [
    { id: 1, date: '2023-10-01', user: 'John Doe', changes: 'Changed status from pending to approved' },
    { id: 2, date: '2023-10-02', user: 'Jane Smith', changes: 'Updated description' },
    // Add more rows as needed
];

const ServiceRequestEditLogs: React.FC = () => {
    return (
        <Table sx={{ width: '100%' }}>
            <TableHead>
                <TableRow>
                    <TableCell sx={{fontWeight: 600}}>Date</TableCell>
                    <TableCell sx={{fontWeight: 600}}>User</TableCell>
                    <TableCell sx={{fontWeight: 600}}>Changes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.id}>
                        <TableCell>{row.date}</TableCell>
                        <TableCell>{row.user}</TableCell>
                        <TableCell>{row.changes}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default ServiceRequestEditLogs;